import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  constructor(
    private r:Router
  ) { }

  ngOnInit(): void {
  }

  login(){
    this.r.navigate(['/admin/login'])
  }
  register(){
    this.r.navigate(['/admin/dashboard'])
  }

}
